export const createChunks = <T>(data: T[], chunkSize: number): T[][] => {
  if (chunkSize < 1) {
    throw new Error(`Cannot create chunks with ${chunkSize} elements`);
  }

  if (data.length === 0) {
    // Make sure return value is always a nested array
    return [data];
  }

  return data.reduce((acc, val, idx) => {
    const chunkIndex = Math.floor(idx / chunkSize);

    if (acc[chunkIndex]) {
      acc[chunkIndex].push(val);
    } else {
      acc[chunkIndex] = [val];
    }
    return acc;
  }, [] as T[][]);
};
